(function($, undefined) {
	'use strict';
    var responsiveDetectorSm;
    var slickSm;
    var desktopActive = true;
    var sendEventDetailsBtn;
    var deleteEventSubscriberBtn;

    var checkWidth = function() {
        if (responsiveDetectorSm.css('visibility') === 'hidden') {
            if (desktopActive === false) {
                slickSm.slick('unslick');
                desktopActive = true;
            }
        } else {
            if (desktopActive === true) {
                slickInitSm();
                desktopActive = false;
            }
        }
    };

    var slickInitSm = function() {
        $('.slick-sm').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            slide: '.stat-box-slide-outer-ctn:not(.phase-2)'
        });
    };

	var init = function() {
        responsiveDetectorSm = $('.responsive-detector-sm');
        sendEventDetailsBtn = $('.send-event-details-btn');
        sendEventDetailsBtn.click(sendEventDetailsByEmail);
        deleteEventSubscriberBtn = $('.delete-event-subscriber-btn');
        deleteEventSubscriberBtn.click(updateSubscribersList);
        slickSm = $('.slick-sm');
        
        checkWidth();
        $(window).resize(function() {
            checkWidth();
        });
	};
	
	$(window).on('load',function(){
		init();
	});

    function sendEventDetailsByEmail() {
        var t = $(this);
        let form = t.closest('form');
        let email = encodeURIComponent(form.find('input[name="email"]').val());
        let eventId = form.find('input[name="event_id"]').val();
        let type = form.find('select[name="types"]').val();
        console.log(email);
        console.log(eventId);
        console.log(type);
        if (email != null && email.length !== 0) {
            if (type == "immediately") {
                $.ajax({
                    url: '/action/epSendEventStats?sendEventReportWhenSubmittingEmail=true&eventId=' + eventId + '&receiver=' + email,
                    cache: false,
                    data: {
                        ajax: true
                    },
                    success: function (response) {
                        alert("succès");
                    },
                    error: function (xhr, textStatus) {
                        alert("échoué");
                    }
                });
            } else if (type == "daily") {
                var url = '/action/manageGenData';
                url += '?field1=ep-event-report-emails';
                url += '&field2=' + eventId;
                url += '&field3=' + email;
                url += '&ajax=true';
                console.log(url);
                $.ajax({
                    url: url,
                    cache: false,
                    data: {
                        ajax: true
                    },
                    success: function (response) {
                        if (response === "success-0") {
                            alert("l'email existe déjà");
                        } else {
                            alert("succès");
                        }
                        // window.location.reload();
                    },
                    error: function (xhr, textStatus) {
                        alert("échoué");
                    }
                });
            } else {
                var url = '/action/manageGenData';
                url += '?field1=ep-event-report-emails-weekly';
                url += '&field2=' + eventId;
                url += '&field3=' + email;
                url += '&ajax=true';
                console.log(url);
                $.ajax({
                    url: url,
                    cache: false,
                    data: {
                        ajax: true
                    },
                    success: function (response) {
                        if (response === "success-0") {
                            alert("l'email existe déjà");
                        } else {
                            alert("succès");
                        }
                        // window.location.reload();
                    },
                    error: function (xhr, textStatus) {
                        alert("échoué");
                    }
                });
            }
        } else {
            alert("Email cannot be empty!");
        }
    }

    function updateSubscribersList() {
        if (confirm('Êtes-vous sûr de vouloir supprimer cet abonné?')) {
            // Delete it!
            var t = $(this);
            let form = t.closest('form');
            let id = t.attr("id");
            let eventId = form.find('input[name="event_id_' + id + '"]').val();
            let email = form.find('input[name="subscriber_' + id + '"]').val();
            let epEventReportEmails = form.find('input[name="ep-event-report-emails_' + id + '"]').val();
            var data = {
                id: id,
                field1: epEventReportEmails == "true" ? 'ep-event-report-emails-deleted' : "ep-event-report-emails-weekly-deleted",
                field2: eventId,
                field3: email,
                ajax: true
            };
            $.ajax({
                url: '/action/manageGenData',
                cache: false,
                data: data,
                method: 'POST',
                success: function (response) {
                    alert("succès");
                    window.location.reload();
                },
                error: function (xhr, textStatus) {
                    alert("échoué");
                }
            });
        } else {
            // Don't delete!
        }
    }

})(jQuery);